// extracted by mini-css-extract-plugin
export default {"container":"contributePage-module--container--PN8BN","link":"contributePage-module--link--fa8PM"};